import {Component, Input, ChangeDetectionStrategy} from '@angular/core';


@Component({
  selector: 'app-skeleton-card',
  standalone: true,
  imports: [],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './skeleton-card.component.html'
})
export class SkeletonCardComponent {
  @Input() height = '208px';
}
